import React from 'react';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

import './style.sass';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';

const History = ({ center, children = '' }) => {
    return (
        <ScrollAnimation animateIn="fadeIn" offset={0} animateOnce={true} duration={1}>
            <FullWrapper isMargin={false} caseName="main-title">
                <div className="main-title__main-wrap">
                    <div
                        className={`main-title__main-container ${
                            center && 'main-title__main-container--center'
                        }`}
                    >
                        <ScrollAnimation
                            animateIn="fadeIn"
                            delay={500}
                            offset={0}
                            animateOnce={true}
                            duration={1}
                            className="main-title__text-container"
                        >
                            <div className="history-title__title">
                                Гарантийный Фонд Ростовской области
                            </div>
                            <div className="history-title__sublink">
                                <a
                                    href="https://dongarant.ru/"
                                    target="_blank"
                                    rel="nofollow noopener noreferrer"
                                >
                                    dongarant.ru
                                </a>
                            </div>

                            <div className="history-title__description">
                                Помогает малому и среднему бизнесу развиваться, предоставляя
                                поручительства и гарантии по банковским кредитам, займам, банковским
                                гарантиям, аккредитиву, лизингу.
                            </div>
                        </ScrollAnimation>
                    </div>
                </div>
                <ScrollAnimation animateIn="fadeIn" offset={100} animateOnce={true} duration={1}>
                    <div
                        className="main-title__info-container"
                        style={children ? { display: 'block' } : { display: 'none' }}
                    >
                        {children}
                    </div>
                </ScrollAnimation>
            </FullWrapper>
        </ScrollAnimation>
    );
};

export default History;
